// src/Paginas/FilterChips.jsx
import React from 'react';

/**
 * FilterChips — horizontal pill-button bar for filtering products by category.
 *
 * @param {Array}    categorias      - Array of { id, nomCategoria } objects from useCategorias
 * @param {number|null} activeFilter - Currently active category id, or null for "Todo"
 * @param {Function} onFilterChange  - Called with (categoryId | null) when a chip is clicked
 */
const FilterChips = ({ categorias = [], activeFilter, onFilterChange }) => {
  // Limit to 7 categories so "Todo" + 7 = 8 chips maximum
  const visibleCategorias = categorias.slice(0, 7);

  return (
    <div
      role="group"
      aria-label="Filtrar por categoría"
      className="filter-chips-bar"
    >
      {/* "Todo" chip — always first */}
      <button
        type="button"
        aria-pressed={activeFilter === null}
        className={`filter-chip${activeFilter === null ? ' filter-chip--active' : ''}`}
        onClick={() => onFilterChange(null)}
      >
        Todo
      </button>

      {/* One chip per category */}
      {visibleCategorias.map((cat) => {
        const isActive = activeFilter === cat.id;
        return (
          <button
            key={cat.id}
            type="button"
            aria-pressed={isActive}
            className={`filter-chip${isActive ? ' filter-chip--active' : ''}`}
            onClick={() => onFilterChange(isActive ? null : cat.id)}
          >
            {cat.nomCategoria}
          </button>
        );
      })}
    </div>
  );
};

export default FilterChips;
